"use strict";

(function ($) {
  $(document).ready(function () {
    $("#myTags").tagit({
      fieldName: "tags[]"
    });

    $("#countries li").one("click", function () {
      $("[data-filter-region] > li").css("display", "none");
    });

    $("#countries > li > div > input").change(function () {
      var countryid = $(this).data("id");

      if ($(this).is(":checked")) {
        $('[data-filter-region] > [id="' + countryid + '"]').css("display", "none");
        $('[id="' + countryid + '"]').css("display", "block");

        $('[data-filter-region-mb] > [id="' + countryid + '"]').css("display", "none");
        $('[data-filter-region-mb] > [id="' + countryid + '"]').css("display", "block");
      } else {
        $('[data-filter-region] > [id="' + countryid + '"]').css("display", "none");
        $('[data-filter-region-mb] > [id="' + countryid + '"]').css("display", "none");
      }
    });

    $("#Filters").on("keyup keypress", function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });

    var larguraTela = $(window).width();
    var alturaTela = $(window).height();

    //scroll top on reload
    $(this).scrollTop(0);

    /* interaction to contact map */
    $(".los-angeles-pin").hover(function () {
      $(".los-angeles-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".los-angeles-text").removeAttr("id", "show");
    });

    $(".portland-pin").hover(function () {
      $(".portland-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".portland-text").removeAttr("id", "show");
    });

    $(".bogota-pin").hover(function () {
      $(".bogota-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".bogota-text").removeAttr("id", "show");
    });

    $(".belo-horizonte-pin").hover(function () {
      $(".belo-horizonte-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".belo-horizonte-text").removeAttr("id", "show");
    });

    $(".kansas-pin").hover(function () {
      $(".kansas-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".kansas-text").removeAttr("id", "show");
    });

    $(".dubai-pin").hover(function () {
      $(".dubai-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".dubai-text").removeAttr("id", "show");
    });

    $(".patrocinio-pin").hover(function () {
      $(".patrocinio-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".patrocinio-text").removeAttr("id", "show");
    });

    $(".branford-pin").hover(function () {
      $(".branford-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".branford-text").removeAttr("id", "show");
    });

    $(".new-york-pin").hover(function () {
      $(".new-york-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".new-york-text").removeAttr("id", "show");
    });

    $(".greenville-pin").hover(function () {
      $(".greenville-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".greenville-text").removeAttr("id", "show");
    });

    $(".atlanta-pin").hover(function () {
      $(".atlanta-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".atlanta-text").removeAttr("id", "show");
    });

    $(".plantation-pin").hover(function () {
      $(".plantation-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".plantation-text").removeAttr("id", "show");
    });

    $(".london-pin").hover(function () {
      $(".london-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".london-text").removeAttr("id", "show");
    });

    $(".gothenburg-pin").hover(function () {
      $(".gothenburg-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".gothenburg-text").removeAttr("id", "show");
    });

    $(".berlin-pin").hover(function () {
      $(".berlin-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".berlin-text").removeAttr("id", "show");
    });

    $(".lausanne-pin").hover(function () {
      $(".lausanne-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".lausanne-text").removeAttr("id", "show");
    });

    $(".riga-pin").hover(function () {
      $(".riga-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".riga-text").removeAttr("id", "show");
    });

    $(".addis-pin").hover(function () {
      $(".addis-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".addis-text").removeAttr("id", "show");
    });

    $(".san-jose-pin").hover(function () {
      $(".san-jose-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".san-jose-text").removeAttr("id", "show");
    });

    $(".san-francisco-pin").hover(function () {
      $(".san-francisco-text").attr("id", "show");
      $(".cls-3").attr("id", "hide");
      $(this).removeAttr("id");
    }, function () {
      $(".cls-3").removeAttr("id", "hide");
      $(".san-francisco-text").removeAttr("id", "show");
    });
    /* end interactions to contact map*/

    //slick carrousel
    $(".banner-slick").slick({
      arrows: false,
      autoplay: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear"
      //pauseOnHover: true
      //dots: true
    });

    //animacao no banner home
    if ($(".banner-slick").hasClass("slick-initialized")) {
      $(".banner-shapes .animated").show().addClass("fadeInLeft");
    }

    var position = $("#menu-item-185").position();
    //$(".banner-shapes").css(position);

    // Single coffee
    if (larguraTela > 767) {
      $(".coffee-slick").flickity({
        // disable previous & next buttons and dots
        cellSelector: ".coffee-slide",
        prevNextButtons: true,
        pageDots: false,
        contain: true,
        imagesLoaded: true
      });
    } else {
      $(".coffee-slick").slick({
        arrows: false,
        dots: true,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px"
      });
    }

    //verifica se existe url no background da featured image 2 e define altura da DIV
    if ($("#featuredImage2").val() == "" || $("#featuredImage2").val() == null || $("#featuredImage2").val() == undefined) {
      //nao tem bg
    } else {
      if (larguraTela > 1026) {
        $(".featured-image-2 .featured-image").height("980px");
      }

      if (larguraTela < 1025) {
        $(".featured-image-2 .featured-image").height("600px");
      }

      if (larguraTela < 767) {
        $(".featured-image-2 .featured-image").height("220px");
      }
    }

    $(".coffee-info-carousel").flickity({
      prevNextButtons: false,
      pageDots: true,
      infinite: true
    });

    // 2nd carousel, navigation
    $(".coffee-info-carousel-nav").flickity({
      asNavFor: ".coffee-info-carousel",
      contain: true,
      pageDots: false,
      prevNextButtons: false
    });
    $(".btn.btn-outline").click(function () {
      $(".details").toggle(200);
    });

    //iguala tamanho dos elementos
    if (larguraTela > 767) {
      $(".matchHeight").matchHeight();
    }

    //remove browser scroll ao abrir menu mobile
    $(".navbar-toggle").on("click", function () {
      $("body").toggleClass("no-scroll");
    });

    //arrow-scroll home
    if (larguraTela > 1023) {
      $(window).scroll(function () {
        var windowTop = $(this).scrollTop();
        $(".our-features").each(function () {
          if (windowTop > $(this).offset().top - 800) {
            $(".arrow-scroll").addClass("hidden");
            $(".title-animated").addClass("visible");
          } else {
            $(".arrow-scroll").removeClass("hidden");
            $(".title-animated").removeClass("visible");
          }
        });
      });
    }

    //home - menu show on footer
    if (larguraTela > 991) {
      $(".footer").onScreen({
        doIn: function doIn() {
          // headerDiv.addClass('fixed-bottom');
        },
        doOut: function doOut() {
          // headerDiv.removeClass('fixed-bottom');
        },
        tolerance: 200,
        toggleClass: ""
      });
    }

    //Our Features - Home
    if (larguraTela < 767) {
      $(".our-features").slick({
        arrows: false,
        dots: true,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "15px"
      });

      $(".featured-coffees .slide-xs").slick({
        arrows: false,
        dots: true,
        autoplay: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px"
      });
    }

    //AboutUs - Anima Grafismos
    if (larguraTela > 991) {
      $(".open-up").onScreen({
        doIn: function doIn() {
          $(this).find(".grafismo").removeClass("invisible").addClass("animated fadeIn");
        },
        doOut: function doOut() {
          $(this).find(".grafismo").addClass("invisible").removeClass("animated fadeIn");
        },
        tolerance: 400,
        toggleClass: ""
      });
    }

    //Our People - Open/Close positions
    $(".btn-apply").click(function () {
      var office = $(this).attr("data-apply");
      $("input[name=office_apply]").val(office);
      $(".title-apply").html(office);
    });

    $(".position-header").click(function () {
      $(".details").slideUp();
      var target = $(this).attr("id");
      $(".position-" + target).toggle();

      $(".position-header").each(function () {
        $(this).removeClass("active");
      });

      if ($(".position-" + target).css("display") == "block") {
        $(this).addClass("active");

        if (larguraTela > 767) {
          $(this).find(".position-city").hide();
        }
      }

      //$(this).find('.close').show();
      //$(this).find('.open').hide();

      $(".position-header").each(function () {
        if ($(this).hasClass("active")) {
          $(this).find(".close").show();
          $(this).find(".open").hide();

          if (larguraTela > 767) {
            $(this).find(".position-city").hide();
          }
        } else {
          $(this).find(".close").hide();
          $(this).find(".open").show();

          if (larguraTela > 767) {
            $(this).find(".position-city").show();
          }
        }
      });

      setTimeout(function () {
        $("html,body").animate({
          scrollTop: $(".position-" + target).parent().offset().top - 25
        }, "slow");
      }, 600);
    });
    // End Our People

    //Our Coffee - Filter Tags
    // $('.filter-tags').slick({
    //   arrows: false,
    //   dots: false,
    //   autoplay: false,
    //   infinite: false,
    //   //variableWidth: true,
    //   //slidesToShow: 1,
    //   //slidesToScroll: 1,
    //   centerMode: true,
    //   centerPadding: '0'
    // });

    //smooth scrolling
    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]').not('[href="#0"]').click(function (event) {
      // On-page links
      if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate({
            scrollTop: target.offset().top
          }, 1000, function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });
  });

  //subscribe submit
  var frm = $("#subscribe");
  // frm.submit(function (e) {
  //
  //     e.preventDefault();
  //
  //     $.ajax({
  //         type: frm.attr('method'),
  //         url: frm.attr('action'),
  //         // headers: {'X-Requested-With': 'XMLHttpRequest'},
  //         // crossDomain: false,
  //         data: frm.serialize(),
  //         success: function (data) {
  //             alert('Submission was successful.');
  //             console.log(data);
  //         },
  //         error: function (data) {
  //             alert('An error occurred.');
  //             console.log(data);
  //         },
  //     });
  // });
})(jQuery);

//funcao para scroll
$.fn.scrollView = function () {
  return this.each(function () {
    $("html, body").animate({
      scrollTop: $(this).offset().top
    }, 1000);
  });
};

// To keep our code clean and modular, all custom functionality will be contained inside a single object literal called "checkboxFilter".

var checkboxFilter = {
  // Declare any variables we will need as properties of the object

  // $filters: null,
  $reset: null,
  groups: [],
  outputArray: [],
  outputString: "",

  // The "init" method will run on document ready and cache any jQuery objects we will need.

  init: function init() {
    var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "checkboxFilter" object so that we can share methods and properties between all parts of the object.

    // self.$filters = $('#Filters');
    self.$reset = $("#Reset");
    self.$reset2 = $("#Reset2");
    self.$container = $("#Container");

    // self.$filters.find('fieldset').each(function(){
    //   self.groups.push({
    //     $inputs: $(this).find('input'),
    //     active: [],
    //     tracker: false
    //   });
    // });

    self.bindHandlers();
  },

  // The "bindHandlers" method will listen for whenever a form value changes.

  bindHandlers: function bindHandlers() {
    var self = this;

    // self.$filters.on('change', function(){
    //   self.parseFilters();
    // });

    // Check first load page
    $(window).load(function (e) {
      e.preventDefault();
      // self.$filters[0].reset();
      self.parseFilters();
    });

    self.$reset.on("click", function (e) {
      e.preventDefault();
      // self.$filters[0].reset();
      self.parseFilters();
    });

    self.$reset2.on("click", function (e) {
      e.preventDefault();
      // self.$filters[0].reset();
      self.parseFilters();
    });
  },

  // The parseFilters method checks which filters are active in each group:

  parseFilters: function parseFilters() {
    var self = this;

    // loop through each filter group and add active filters to arrays

    var $matching = [];
    for (var i = 0, group; group = self.groups[i]; i++) {
      group.active = []; // reset arrays
      group.$inputs.each(function () {
        $(this).is(":checked") && group.active.push(this.value);
      });
      group.active.length && (group.tracker = 0);
    }

    inputText = $("#search-filter").val().toLowerCase();
    // Check to see if input field is empty
    if (inputText.length > 0) {
      $(".col-xs-12.col-sm-6.col-lg-3.coffee-item").each(function () {
        var $this = $(this);
        // add item to be filtered out if input text matches items inside the title
        if ($this.attr("data-name").toLowerCase().match(inputText)) {
          $matching.push("." + $this.data("id"));
        }
      });

      self.groups[4].active = $matching;
    }

    for (var i = 0, group; group = self.groups[i]; i++) {
      group.active.length && (group.tracker = 0);
    }

    self.concatenate();
  },

  // The "concatenate" method will crawl through each group, concatenating filters as desired:

  concatenate: function concatenate() {
    var self = this,
        cache = "",
        crawled = false,
        checkTrackers = function checkTrackers() {
      var done = 0;

      for (var i = 0, group; group = self.groups[i]; i++) {
        group.tracker === false && done++;
      }

      return done < self.groups.length;
    },
        crawl = function crawl() {
      for (var i = 0, group; group = self.groups[i]; i++) {
        group.active[group.tracker] && (cache += group.active[group.tracker]);

        if (i === self.groups.length - 1) {
          self.outputArray.push(cache);
          cache = "";
          updateTrackers();
        }
      }
    },
        updateTrackers = function updateTrackers() {
      for (var i = self.groups.length - 1; i > -1; i--) {
        var group = self.groups[i];

        if (group.active[group.tracker + 1]) {
          group.tracker++;
          break;
        } else if (i > 0) {
          group.tracker && (group.tracker = 0);
        } else {
          crawled = true;
        }
      }
    };

    self.outputArray = []; // reset output array

    do {
      crawl();
    } while (!crawled && checkTrackers());

    self.outputString = self.outputArray.join();

    // If the output string is empty, show all rather than none:

    !self.outputString.length && (self.outputString = "all");

    //console.log(self.outputString);
    localStorage.setItem("filter", self.outputString);

    // ^ we can check the console here to take a look at the filter string that is produced

    // Send the output string to MixItUp via the 'filter' method:

    if (self.$container.mixItUp("isLoaded")) {
      self.$container.mixItUp("filter", self.outputString);
    }
  }
};

$(function () {
  // checkboxFilter.init();

  $("#Container").mixItUp({
    multifilter: {
      enable: true,
      parseOn: "change"
    },

    load: {
      filter: localStorage.getItem("filter") != null ? localStorage.getItem("filter") : "all",
      sort: localStorage.getItem("sort") != null ? localStorage.getItem("sort") : "published-date:desc"
    },

    callbacks: {
      onMixStart: function onMixStart(state, futureState) {
        //console.log(futureState.activeFilter.selector);
      }
    },
    selectors: {
      target: ".col-xs-12.col-sm-6.col-lg-3.coffee-item", // As in mixitup
      sort: ".sort-coffee"
    },
    layout: {
      display: "inline-block" // As in mixitup
    },
    loadmore: {
      // The number of items to start with
      initial: 12,
      // The number of items to load on click on the loadmore button
      loadMore: 12,
      // A selector string for the existing wrapper the buttons will be inserted into
      buttonWrapper: ".loadmore",
      // The class of the Load more button
      buttonClass: "loadmore-button btn btn-outline btn-outline-dark",
      // The label of the Load more button
      buttonLabel: "Load more",
      // The class of the less button
      lessClass: "loadmore-less",
      // The label of the less button
      lessLabel: "Reset"
    }
  });
});

var inputText;
var $matching = $();
var delay = function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}();
// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $(".header").outerHeight();

$(window).scroll(function (event) {
  didScroll = true;
});

setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  var larguraTela = $(window).width();

  var st = $(this).scrollTop();

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return;

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    $(".header").removeClass("nav-down").addClass("nav-up");
  } else {
    // Scroll Up
    if (st + $(window).height() < $(document).height()) {
      $(".header").removeClass("nav-up").addClass("nav-down");
    }
  }

  lastScrollTop = st;
}

//salesForce
function sendWeb2Lead() {
  //Dispara para Salesforce
  $('<iframe style="display:none;" name="iframe-salesforce-allycoffee-subscribe"/>').appendTo("body");

  var email = $('#allycoffee-subscribe-form  input[name="email"]').val();

  var form = document.createElement("form");
  form.method = "POST";
  form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
  form.name = "form-salesforce-allycoffee-subscribe";
  form.id = "form-salesforce-allycoffee-subscribe";
  form.target = "iframe-salesforce-allycoffee-subscribe";

  // Your org ID
  var elementOID = document.createElement("input");
  elementOID.name = "oid";
  elementOID.value = "00D15000000NBGY";
  elementOID.setAttribute("type", "hidden");
  form.appendChild(elementOID);

  // SFDC redirects to retURL in the response to the form post
  var elementRetURL = document.createElement("input");
  elementRetURL.name = "retURL";
  elementRetURL.value = location.protocol + "//" + location.host;
  elementRetURL.setAttribute("type", "hidden");
  form.appendChild(elementRetURL);

  var elementEmail = document.createElement("input");
  elementEmail.name = "email"; //E-mail 00N2F000000gbCX
  elementEmail.value = email;
  elementEmail.setAttribute("type", "hidden");
  form.appendChild(elementEmail);

  document.body.appendChild(form);

  $("#form-salesforce-allycoffee-subscribe").submit();
  $("#form-salesforce-allycoffee-subscribe").remove();

  return false;
}

//basket
var basket = [];
window.initBasketHandlers = function initBasketHandlers() {
  $("#form-basket .loader").hide();
  if ($("#form-basket").length) {
    $("#form-basket").validate({
      submitHandler: function submitHandler(form) {
        $(".btn").hide("fast");
        $("#form-basket .loader").fadeIn("fast");
        var dataArray = $("#form-basket").serializeArray();
        $.post($("#form-basket").attr("action") + "/submit-sample-basket.php", dataArray, function (data) {
          if (data == "success") {
            basket = [];
            $.cookie("baskets", JSON.stringify(basket), { path: "/" });
            swal("Success!", "Your request was sent successfully!", "success");
            $("#form-basket .form-control").val("");
            $(".btn").fadeIn("fast");
            $("#form-basket .loader").hide();
          } else {
            swal("Ops!", "Something went wrong!", "error");
          }
          $(".btn").fadeIn("fast");
          $("#form-basket .loader").hide();
        });
      }
    });
  }

  basket = $.cookie("baskets");
  if (basket == null) {
    basket = [];
    $.cookie("baskets", JSON.stringify(basket), { path: "/" });
  } else {
    try {
      basket = JSON.parse(basket);
    } catch (e) {
      console.log("basket mal formado");
      basket = [];
    }
  }

  if (basket.constructor !== Array) {
    basket = [];
  }

  $(".btn-basket .badge").html(basket.length);

  $(".btn-add-basket").each(function (index, element) {
    var id = $(element).attr("data-sample");
    if (basket.includes(id)) {
      $(element).hide();
      $(element).parent().find(".btn-close-basket").show();
    }
  });

  $(".btn-add-basket").click(function () {
    $(this).hide();
    var id = $(this).attr("data-sample");
    if (!basket.includes(id)) {
      basket.push(id);
      swal({
        title: "Coffee added!",
        text: "Sample request added to your cart.",
        timer: 2000,
        type: "success",
        showConfirmButton: false
      });
      $.cookie("baskets", JSON.stringify(basket), { path: "/" });
      $(".btn-basket .badge").html(basket.length);
      $(this).parent().find(".btn-close-basket").show();
    }
    return false;
  });

  $("#select").change(function () {
    var val = $(this).val();

    if (val === "United States") {
      $("#state").show();
    } else {
      $("#state").hide();
    }
  });
};

//basket
window.initBasketHandlers();